import { normalize } from "normalizr";
import { all, call, put, takeLatest } from "redux-saga/effects";

import {
    LastVisitCounts,
    forumHeaderUpdate,
    forumUpdateComplaintsStatistics,
} from "@/mk2/apps/forum/actions";
import {
    FORUM_FEED_LOAD,
    ForumFeedFetchNormalizedResponse,
    ForumFeedFetchRequestAction,
    forumFeedFetch,
} from "@/mk2/apps/forum/containers/ForumFeed/ForumFeed.actions";
import {
    BrandDaysCampaignEntity,
    BrandDaysCampaignSchema,
    ComplaintsStatisticsPerPost,
    MyAnonymousPostSchema,
    PostEntity,
    PostSchema,
} from "@/mk2/apps/forum/schemas";
import { XHRAction, normalizeError } from "@/mk2/helpers/api";
import { getLogger } from "@/mk2/logger";
import { forum_api_feed_url } from "@/mk/urls/functions";

const logger = getLogger("forum/ForumFeed.sagas");

interface ApiResponsePosts {
    body: {
        posts: PostEntity[];
        hasNext: number;
        hasPrevious: number;
        lastVisitCounts: LastVisitCounts;
        notificationsOn: number[];
        complaintsStatistics: ComplaintsStatisticsPerPost;
        topicsCount: number;
        activeBrandDays: { posts: PostEntity[]; campaign: BrandDaysCampaignEntity };
    };
}

function* fetchForumFeed({ after, orderBy, xhr }: ForumFeedFetchRequestAction & XHRAction) {
    yield put(forumFeedFetch.request(orderBy, after));

    try {
        const response: ApiResponsePosts = yield call(() =>
            xhr.get(forum_api_feed_url(), { after, orderby: orderBy }),
        );

        const normalizedResponse: ForumFeedFetchNormalizedResponse = normalize(response.body, {
            posts: [PostSchema],
            myAnonymousPosts: [MyAnonymousPostSchema],
            activeBrandDays: { posts: [PostSchema], campaign: BrandDaysCampaignSchema },
        });

        yield put(forumUpdateComplaintsStatistics(response.body.complaintsStatistics));
        yield put(
            forumFeedFetch.success(
                orderBy,
                after,
                response.body.hasNext,
                response.body.hasPrevious,
                response.body.notificationsOn,
                response.body.topicsCount,
                normalizedResponse,
            ),
        );
        yield put(forumHeaderUpdate(response.body.lastVisitCounts));
    } catch (error) {
        logger.error(error);

        yield put(forumFeedFetch.failure(orderBy, after, normalizeError(error)));
    }
}

export default function* root() {
    yield all([takeLatest(FORUM_FEED_LOAD, fetchForumFeed)]);
}
